import { render, staticRenderFns } from "./via_in_pad.vue?vue&type=template&id=56d34b30"
import script from "./via_in_pad.vue?vue&type=script&lang=js"
export * from "./via_in_pad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports